// 현재 HCR에서는 DELIVERY만 사용되고 있음
// https://barogo.slack.com/archives/C02GJBMBU6B/p1704261954855829?thread_ts=1704261472.059369&cid=C02GJBMBU6B
export default {
    // 주문
    ORDER: 'ORDER',
    // 배달
    DELIVERY: 'DELIVERY',
    // 퀵
    QUICK: 'QUICK',
    // 주문→배달
    ORDER_TO_QUICK: 'ORDER_TO_QUICK',
};
